<template>
  <div class="body">
    <el-card class="box-card" shadow="always">
      <div slot="header">
        <el-row>
          <el-col :span="16">
            <h3 style="font-size: 18px; margin-top: 10px; margin-bottom: 0px;">
              INVENTARIO DE RIESGOS
              <br />
            </h3>
          </el-col>
          <el-col :span="8">
            <img style="float: right;" src="../assets/AntofagastaMinerals.jpg" width="100px" />
          </el-col>
        </el-row>
      </div>
      <el-alert center v-bind:title="error" type="error" v-if="error" show-icon :closable="false"></el-alert>

      <el-form
        v-if="!$store.getters.isLoggedIn"
        :model="credentials"
        status-icon
        :rules="rulesLogin"
        ref="formLogin"
      >
        <el-form-item style="margin-bottom: 10px;" prop="rut" label="Nombre de usuario / RUT">
          <el-input :placeholder="$t('Ingrese RUT')" v-model="credentials.rut"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="Contraseña">
          <el-input
            type="password"
            :placeholder="$t('Ingrese contraseña')"
            @keyup.native.enter="submit"
            v-model="credentials.password"
          ></el-input>
        </el-form-item>
      </el-form>
      <div v-else>
        <center>
          Iniciado como
          <b>{{username}}</b>
        </center>
        <br />
      </div>
      <br />
      <center>
        <!--<el-button
          v-if="!$store.getters.isLoggedIn"
          @click="goDashboard"
          size="medium"
          class="buttons-login"
          type="info"
        >IR A DASHBOARD</el-button>-->
        <el-button
          v-if="$store.getters.isLoggedIn"
          @click="plataforma"
          size="medium"
          class="buttons-login"
          type="info"
        >IR A PLATAFORMA</el-button>
        <el-button
          v-if="!$store.getters.isLoggedIn"
          @click="submit"
          size="medium"
          class="buttons-login"
          type="primary"
        >INICIAR SESIÓN</el-button>
        <el-button
          v-if="$store.getters.isLoggedIn"
          @click="signOut"
          size="medium"
          class="buttons-login"
          type="danger"
        >CERRAR SESIÓN</el-button>
      </center>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "SafetyLogin",
  data() {
    return {
      isLoading: false,
      credentials: {
        rut: "",
        password: ""
      },
      error: "",
      rulesLogin: {
        password: [{ validator: this.validatePass, trigger: "blur" }],
        rut: [{ validator: this.validateRUT, trigger: "blur" }]
      }
    };
  },
  computed: {
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    }
  },
  methods: {
    goDashboard() {
      window.location = "https://release.amsa.lifeon.cl/dashboard";
    },
    async signOut() {
      // reset datos de otros roles
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserAllContracts");
      await this.$store.dispatch("resetUserContractByRole");
      await this.$store.dispatch("latestState", null);

      await this.$store.dispatch("logout");
      this.$router.push({ name: "homePage" });
    },
    plataforma() {
      this.redirectLoggedUser();
    },
    validatePass(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("Por favor, ingresa tu contraseña")));
      } else {
        callback();
      }
    },
    validateRUT(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("Por favor, ingresa tu RUT")));
      } else {
        callback();
      }
    },
    formatRUT(rut) {
      // Despejar Puntos
      let valor = rut.replace(/\./g, "");
      // Despejar Guión
      valor = valor.replace("-", "");
      return valor;
    },
    checkRut(rut) {
      const valor = this.formatRUT(rut);
      // Aislar Cuerpo y Dígito Verificador
      const cuerpo = valor.slice(0, -1);
      let dv = valor.slice(-1).toUpperCase();

      // Si no cumple con el mínimo ej. (n.nnn.nnn)
      if (cuerpo.length < 7) return false;

      // Calcular Dígito Verificador
      let suma = 0;
      let multiplo = 2;

      // Para cada dígito del Cuerpo
      for (let i = 1; i <= cuerpo.length; i += 1) {
        // Obtener su Producto con el Múltiplo Correspondiente
        const index = multiplo * valor.charAt(cuerpo.length - i);

        // Sumar al Contador General
        suma += index;

        // Consolidar Múltiplo dentro del rango [2,7]
        if (multiplo < 7) {
          multiplo += 1;
        } else {
          multiplo = 2;
        }
      }
      // Calcular Dígito Verificador en base al Módulo 11
      const dvEsperado = 11 - (suma % 11);

      // Casos Especiales (0 y K)
      dv = dv === "K" ? 10 : dv;
      dv = dv === 0 ? 11 : dv;

      // Validar que el Cuerpo coincide con su Dígito Verificador
      if (dvEsperado.toString() !== dv) {
        return false;
      }
      // Si todo sale bien, eliminar errores (decretar que es válido)
      return true;
    },
    async submit() {
      this.isLoading = true;
      this.$refs.formLogin.validate(async valid => {
        if (valid) {
          const response = await this.$store.dispatch(
            "login",
            this.credentials
          );
          if (!response.success) {
            this.isLoading = false;
            this.error = response.error;
            return;
          }
          this.redirectLoggedUser();
        } else {
          this.isLoading = false;
        }
      });
    },
    setGoogle() {
      // Setea usuario en Google Analytics
      this.$ga.set("admin", this.$store.getters.role.admin || false);
      this.$ga.set("account_type", this.$store.getters.role.role);
      this.$ga.set("account", this.credentials.rut);
      this.$ga.set(
        "account_name",
        `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`
      );
    },
    async redirectLoggedUser() {
      const haveAccess = await this.$store.dispatch("getRoles");
      await this.$store.dispatch("setRole");
      this.setGoogle();
      this.$router.push({ name: "SelectRoles" });
    }
  }
};
</script>

<style scoped>
.body {
  background: url("../assets/fondo-login.jpg");
  height: 100vh;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center;
}
.box-card {
  padding: 10px;
  width: 430px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.login {
  /*position: absolute;*/
  padding: 50px 50px 40px 50px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  max-width: 400px;
  /*top: 40px;
  left: 60px;*/
  /*box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.75);*/
  border: 2px solid #ccc;

  margin: 0 auto;
  margin-top: 80px;
}

.title {
  color: rgb(246, 123, 47);
  font-weight: bold;
  font-size: 25px;
  margin-top: 30px;
  margin-bottom: 10px;
}

.logo-bhp {
  max-width: 100%;
}

.logo-escondida {
  max-width: 100%;
}

.el-alert {
  margin-bottom: 10px;
}

.button {
  width: 100%;
}

@media (max-width: 768px) {
  .login {
    border: none;
    margin-top: 40px;
    margin-right: 10px;
    margin-left: 10px;
    position: static;
    padding: 30px 30px 20px 30px;
  }
}
</style>
